import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InternalAppService } from 'src/services/app.service';
import { Router } from '@angular/router';

@Component({
  selector:    'cashregister-terminal-config-page',
  standalone:  false,
  templateUrl: './cashregister-terminal-config.page.haml',
  styleUrls:   ['./cashregister-terminal-config.page.sass']
})
export class CashRegisterTerminalConfigPage {
  private appService = inject(InternalAppService);
  private router = inject(Router);
  private fb = inject(FormBuilder);

  configForm: FormGroup;
  errorMessage: string = '';

  constructor() {
    this.configForm = this.fb.group({
      configToken: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  async onSubmit() {
    if (!this.configForm.valid) return;

    const token = this.configForm.get('configToken')?.value;
    const valid = await this.appService.validateConfigToken(token);

    if (valid) {
      this.router.navigate(['/login']).catch(console.error);
    } else {
      this.errorMessage = 'Ungültiger oder abgelaufener Token';
      this.configForm.reset();
    }
  }
}
